module.exports = __webpack_public_path__ + "img/28.e0d9cebe.jpg";